var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',[_c('SFLoader')],1):_c('div',[(_vm.getReports)?_c('div',[_c('SFGrid',{attrs:{"data":_vm.getReports}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }